export default __webpack_public_path__ + "static/media/pic16.a27874ad.jpg";